<template>
  <div class="data-table">
    <div style="position: absolute; width: 100%; height: 100%; left: 0; top: 0;">
      <el-table :summary-method="summaryMethod" show-summary :data="tableData" height="100%" style="width: 100%"
        header-row-class-name="table-header">
        <el-table-column align="center" v-for="item in column" :key="item.prop" :prop="item.prop" :label="item.label"
          :width="item.width">
          <template slot-scope="scope">
            <span class="comparison-number" v-if="!item.slotName">{{ formatCell(scope.row, item) }}</span>
            <slot v-else :name="item.slotName" :row="scope.row" :column="column">
              <div class="comparison-val">
                <img class="comparison-icon" v-if="item.arrows" :src="comparisonIcon(scope.row[item.prop])">
                <!-- <img class="comparison-icon" :src="comparisonIcon(scope.row[item.prop])"> -->
                <span class="comparison-number" :class="comparison(scope.row[item.prop])">
                  <span>{{ formatNumber(scope.row[item.prop]) }}</span>
                  <!-- <span style="margin: 0;">%</span> -->
                  <span v-if="item.arrows" style="margin: 0;">%</span>
                </span>
              </div>
            </slot>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import upwardIcon from '@/assets/upward-icon.png'
import downwardIcon from '@/assets/downward-icon.png'
export default {
  name: 'data-table',
  props: {
    summaryMethod: {
      type: Function,
      default: null
    },
    column: {
      type: Array,
      default: () => [
        {
          prop: 'customerBelonging',
          label: '客户归属',
        },
        {
          prop: 'orderNum',
          label: '客单数',
        },
        {
          prop: 'salesRevenueExcludingTax',
          label: '销售额（不含税）',
        },
        {
          prop: 'salesRevenueIncludingTax',
          label: '销售额（含税）',
        },
        {
          prop: 'salesRevenueRate',
          label: '金额占比',
        },
        {
          prop: 'customerUnitPriceExcludingTax',
          label: '客单价（不含税）',
        },
        {
          prop: 'customerUnitPriceIncludingTax',
          label: '客单价（含税）',
          slotName: 'customerUnitPriceIncludingTaxSlot'
        },
        {
          prop: 'monthOverMonthGrowthRate',
          label: '环比增长率',
          width: '180',
          slotName: 'monthOverMonthGrowthRateSlot'

        },
      ]
    },
    tableData: {
      type: Array,
      default: () => [
        {
          customerBelonging: '钱钱',
          orderNum: 123456789,
          salesRevenueExcludingTax: 123456789,
          salesRevenueIncludingTax: 123456789,
          salesRevenueRate: 123456789,
          customerUnitPriceExcludingTax: 123456789,
          customerUnitPriceIncludingTax: '123456789',
          monthOverMonthGrowthRate: '25'
        },
        {
          customerBelonging: '钱钱',
          orderNum: 123456789,
          salesRevenueExcludingTax: 123456789,
          salesRevenueIncludingTax: 123456789,
          salesRevenueRate: 123456789,
          customerUnitPriceExcludingTax: 123456789,
          customerUnitPriceIncludingTax: '-123456789',
          monthOverMonthGrowthRate: '-25'
        }
      ]
    }
  },
  data() {
    return {
      upwardIcon,
      downwardIcon
    }
  },
  methods: {
    formatNumber(val) {
      return Number(val) < 0 ? -val : val;
    },
    comparison(val) {
      if (val > 0) {
        return 'upward';
      } else {
        return 'downward';
      }
    },
    comparisonIcon(val) {
      if (val > 0) {
        return this.upwardIcon;
      } else {
        return this.downwardIcon;
      }
    },
    formatCell(row, column) {
      if (typeof column.formatter === 'function') {
        return column.formatter(row[column.prop], row, column)
      }
      return row[column.prop]
    },
    // getSummaries(param) {
    // console.log('param', JSON.stringify(param))

  }
}

</script>


<style scoped lang="scss">
.data-table {
  width: 100%;
  height: 100%;
  position: relative;

  .comparison-number {
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    line-height: 25px;
    text-align: center;
  }

  .comparison-val {
    display: flex;
    align-items: center;
    justify-content: center;

    .comparison-icon {
      width: 10px;
      height: 12px;
      margin: 0;
    }

    .upward {
      font-weight: 600;
      color: #0F805A !important;
    }

    .downward {
      font-weight: 600;
      color: #FA5C37 !important;
    }
  }

  ::v-deep .el-table {
    .el-table__header-wrapper {
      .el-table__header {
        .has-gutter {
          .table-header {
            .cell {
              font-weight: 400;
              font-size: 14px;
              color: #000000 !important;
            }
          }
        }
      }
    }

    .el-table__body-wrapper {
      .el-table__body {
        .el-table__row {
          .cell {
            font-weight: 400;
            font-size: 14px;
            color: #000000;
          }
        }
      }
    }

    .el-table__footer-wrapper {
      .el-table__footer {
        .has-gutter {
          .el-table__cell {
            .cell {
              font-weight: 400;
              font-size: 14px;
              color: #000000;
            }
          }
        }
      }
    }
  }
}
</style>
